import { render, staticRenderFns } from "./printSetting.vue?vue&type=template&id=052dff48&"
import script from "./printSetting.vue?vue&type=script&lang=ts&"
export * from "./printSetting.vue?vue&type=script&lang=ts&"
import style0 from "./printSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports